import { render } from "./ProviderFields.vue?vue&type=template&id=55c647ae&scoped=true"
import script from "./ProviderFields.vue?vue&type=script&lang=js"
export * from "./ProviderFields.vue?vue&type=script&lang=js"

import "./ProviderFields.vue?vue&type=style&index=0&id=55c647ae&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c647ae"]])

export default __exports__